import React, { useEffect, useState } from "react";
import Sidebar from "../../components/layouts/Sidebar";
import { Route, Routes, useLocation } from "react-router-dom";
import BuyerDashboard from "./home/Buyer";
import SellerDashboard from "./home/Seller";
import DashboardHeader from "../../components/layouts/DashboardHeader";
import Create from "./listing/Create";
import Update from "./listing/Update";
import List from "./listing/List";
import Preview from "./listing/Preview";
import OpenForBids from "./listing/OpenForBids";
import HelpAndSupport from "./HelpAndSupport";
import Profile from "./Profile";
import UpdateAdInProgress from "./listing/UpdateAdInProgress";
import Watchlist from "./Watchlist";
import Bids from "./Bids";
import Disputes from "./Disputes";
import Reviews from "./Reviews";
import MyReviews from "./MyReviews";
import { usePersistStore } from "../../store";
import { DASHBOARD_TYPE } from "../../utils/enums";
import { getDashboardForPath } from "../../utils/dashboard-routes";
import BuyerPayments from "./BuyerPayments";
import SellerPayments from "./SellerPayments";
import TrustapAccount from "./TrustapAccount";
import TrustapAccountCallback from "./TrustapAccountCallback";
import Review from "../review/Review";
import Followers from "./Followers";
import Following from "./Following";

function Layout() {
  const { dashboardType, setDashboardType } = usePersistStore((s: any) => s);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const closeDrawer = () => setDrawerOpen(false);
  const toggleDrawer = () => setDrawerOpen((v) => !v);

  const location = useLocation();
  useEffect(() => {
    closeDrawer();
  }, [location.pathname]);

  // Make the current route the source of truth for which dashboard the
  // sidebar shows. When a notification, deep link, or browser back/forward
  // lands the user on a screen that belongs to the OTHER side (e.g. seller
  // mode + /dashboard/bids), flip dashboardType so the sidebar menu and
  // the active item match where they actually are. `shared` routes
  // (/dashboard, /profile, /help-and-support) preserve the existing mode.
  useEffect(() => {
    const owner = getDashboardForPath(location.pathname);
    if (owner !== "shared" && owner !== dashboardType) {
      setDashboardType(owner);
    }
  }, [location.pathname, dashboardType, setDashboardType]);

  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        minHeight: "100vh",
      }}
    >
      <Sidebar drawerOpen={drawerOpen} onCloseDrawer={closeDrawer} />
      <main className="dashboardMain">
        <DashboardHeader onHamburgerClick={toggleDrawer} />
        <Routes>
          <Route
            path=""
            element={
              dashboardType === DASHBOARD_TYPE.BUYER ? (
                <BuyerDashboard />
              ) : (
                <SellerDashboard />
              )
            }
          />
          <Route path="create" element={<Create />} />
          <Route path="update/:adId" element={<Update />} />
          <Route path="preview" element={<Preview />} />
          <Route path="update-preview" element={<UpdateAdInProgress />} />
          <Route path="listing" element={<List />} />
          <Route path="open-for-bids" element={<OpenForBids />} />
          <Route path="bids" element={<Bids />} />
          <Route path="buyer-payments" element={<BuyerPayments />} />
          <Route path="seller-payments" element={<SellerPayments />} />
          <Route path="help-and-support" element={<HelpAndSupport />} />
          <Route path="profile" element={<Profile />} />
          <Route path="watchlist" element={<Watchlist />} />
          <Route path="disputes" element={<Disputes />} />
          <Route path="reviews" element={<Reviews />} />
          <Route path="my-reviews" element={<MyReviews />} />
          <Route path="review/:adId" element={<Review />} />
          <Route path="followers" element={<Followers />} />
          <Route path="following" element={<Following />} />
          <Route path="trustap-account" element={<TrustapAccount />} />
          <Route
            path="trustap-account-callback"
            element={<TrustapAccountCallback />}
          />
        </Routes>
      </main>
    </div>
  );
}

export default Layout;
